import InputValidationController from "./input_validation_controller";

export default class extends InputValidationController {
  validate() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.inputTarget.value);
  }
}
